import React from "react";
import { Flex, IconButton, Input } from "@chakra-ui/react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Pagination = ({
  colorMode,
  objectCount,
  hasPrevious,
  hasNext,
  goPrevious,
  goNext,
  searchPageIndex,
  onSearchIndexChange,
  handleKeyDown,
  pageCount,
}) => {
  return (
    <Flex gap={4} mt={4} justify="space-between" w="full" alignItems="center">
      <Flex gap={2} color={colorMode === "light" ? "inherit" : "black"}>
        Total: {objectCount}
      </Flex>
      <Flex gap={5} alignItems="center">
        <IconButton
          variant="pageButton"
          icon={<IoIosArrowBack />}
          onClick={goPrevious}
          isDisabled={!hasPrevious}
          aria-label="previous"
        />
        {Math.ceil(objectCount / 10) > 1 && (
          <Input
            type="number"
            min="1"
            max={Math.ceil(objectCount / 10)}
            width="20"
            value={searchPageIndex}
            onChange={onSearchIndexChange}
            onKeyDown={handleKeyDown}
          />
        )}
        <Flex color={colorMode === "light" ? "inherit" : "white"} gap={2}>
          {pageCount} / {Math.ceil(objectCount / 10)}
        </Flex>
        <IconButton
          variant="pageButton"
          icon={<IoIosArrowForward />}
          onClick={goNext}
          isDisabled={!hasNext}
          aria-label="next"
        />
      </Flex>
    </Flex>
  );
};

export default Pagination;
